export const backendUrl = process.env.REACT_APP_BACKEND_URL || "/api/";

export const RoutesPaths = {
  // Sign in, sign up and the assistant steps each have their own address;
  // they used to share "/", which left the URL saying nothing about where the
  // user was and no way to link to one of them.
  LOGIN: "/",
  SIGNUP: "/signup",
  CREATE_ASSISTANT: "/create-assistant",
  VERIFY_OTP: "/verify-otp",
  FORGOT_PASSWORD: "/forgot-password",
  DASHBOARD: "/dashboard",
  CUSTOMIZATION: "/customization",
  BILLING: "/billing",
  INSTALL_SETTINGS: "/install-settings",
  CONVERSATIONS: "/conversations",
  ANALYTICS: "/analytics",
  ASSISTANT: "/assistant",
  INTEGRATIONS: "/integrations",
  ACCOUNT_SETTINGS: "/account-settings",
  TRAINING_BOT: "/training-assistant",
  CHECKOUT: "/checkout",
};
